import axiosInstance from "./axios";

export const fetchBanks = async (search = null) => {
  return axiosInstance.get("/banks", {
    params: { search: search || undefined },
  });
};

export const createBank = async (data) => {
  return axiosInstance.post("/banks", data);
};

export const updateBank = async (id, data) => {
  return axiosInstance.put(`/banks/${id}`, data);
};

export const deleteBank = async (id) => {
  return axiosInstance.delete(`/banks/${id}`);
};
